import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-multi-lang";
import { useSelector } from "react-redux";
import StatusBadge from "./StatusBadge";
import { display } from "../Utility/Utility";

const ViewPayoutrequestModal = ({ payout, onHide }) => {

  const t = useTranslation("payout_transactions")

  const profile = useSelector((state) => state.admin.profile);

  const {
    order_id,
    customer_id,
    utr_number,
    status_formatted,
    service_fee_formatted,
    amount_formatted,
    tax_fee_formatted,
    payment_mode,
    upi_id,
    ifsc_code,
    account_number,
    account_holder_address,
    account_holder_name,
    created_at,
    updated_at
  } = payout || {};

  return (
    <>

      <Offcanvas show={!!payout} onHide={onHide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title> {t("payout_details")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="view-modal-wrap">
            <div className="view-modal-card-wrap">
              <div className="view-modal-card">
                <div>{t("settlement_table.payment_id")}</div>
                <div>{display(order_id)}</div>
              </div>
              <div className="view-modal-card">
                <div>{t("settlement_table.customer_id")}</div>
                <div>{display(customer_id)}</div>
              </div>
              <div className="view-modal-card">
                <div>{t("settlement_table.utr_number")}</div>
                <div>{display(utr_number)}</div>
              </div>
              <div className="view-modal-card">
                <div>{t("amount")}</div>
                <div> {display(amount_formatted)}</div>
              </div>
              {profile.data.show_payout_commission ? (
                <div className="view-modal-card">
                  <div>{t("service_fee")}</div>
                  <div>{display(service_fee_formatted)}</div>
                </div>
              ) : null}
            </div>

            <div className="view-modal-card-wrap">
              {profile.data.show_service_provider_commission ? (
                <div className="view-modal-card">
                  <div>{t("tax_fee")}</div>
                  <div> {display(tax_fee_formatted)}</div>
                </div>
              ) : null}

              {display(payment_mode == "UPI" ? <React.Fragment>
                <div className="view-modal-card">
                  <div>{t("upi_id.name")}</div>
                  <div>{display(upi_id)}</div>
                </div>
              </React.Fragment> :

                <React.Fragment>

                  <div className="view-modal-card">
                    <div>{t("beneficiaryAccount.name")}</div>
                    <div>{display(account_number)}</div>
                  </div>
                  <div className="view-modal-card">
                    <div>{t("beneficiaryAddress.name")}</div>
                    <div>{display(account_holder_address)}</div>
                  </div>
                  <div className="view-modal-card">
                    <div>{t("beneficiaryIFSC.name")}</div>
                    <div>{display(ifsc_code)}</div>
                  </div>
                </React.Fragment>)}
              <div className="view-modal-card">
                <div>{t("beneficiaryName.name")}</div>
                <div>{display(account_holder_name)}</div>
              </div>
              <div className="view-modal-card">
                <div>{t("paymentMode.name")}</div>
                <div> {display(payment_mode)}</div>
              </div>
            </div>
            <div className="view-modal-card">
              <div>{t("status")}</div>
              <StatusBadge status={display(status_formatted)} />
            </div>
            <div className="view-modal-card">
              <div>{t("created_at")}</div>
              <div>{display(created_at)}</div>
            </div>
            <div className="view-modal-card">
              <div>Updated Date</div>
              <div>{display(updated_at)}</div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewPayoutrequestModal;
